import React from "react";
import FW from "../../../config/word.json";

// メニュー定義
export const homeBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    icon: <img src="/images/icons/home_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/home.svg" alt="" />,
  },
];

export const logOutBar = [
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    icon: <img src="/images/icons/log-out-active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
  },
];

export const approvalGroupBar = [
  {
    title: FW.F_W_HOME_ApprovalList,
    path: "/approvallist",
    icon: (
      <span role="img" aria-label="承認待ち" style={{ fontSize: "20px" }}>
        ⏳
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="承認待ち" style={{ fontSize: "20px" }}>
        ⏳
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_ApprovaledList,
    path: "/approvaledlist",
    icon: (
      <span role="img" aria-label="承認済み" style={{ fontSize: "20px" }}>
        ✅
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="承認済み" style={{ fontSize: "20px" }}>
        ✅
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_RejectList,
    path: "/rejectedlist",
    icon: (
      <span role="img" aria-label="否認" style={{ fontSize: "20px" }}>
        ❌
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="否認" style={{ fontSize: "20px" }}>
        ❌
      </span>
    ),
  },
];
// 基本ボタン
export const menuGroupBar = [
  {
    title: FW.F_W_SYS_HOME,
    path: "/home",
    icon: (
      <img
        src="/images/icons/home_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/home.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_SYS_LOGOUT,
    path: "/",
    icon: (
      <img
        src="/images/icons/log-out-active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/log-out.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

export const fansGroupBar = [
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfo",
    icon: (
      <img
        src="/images/icons/user.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/user_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: "大会管理",
    path: "/daikaiManage",
    icon: (
      <img
        src="/images/icons/calendar-alt.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/calendar-alt-active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: "おすすめ候補者",
    path: "/recommendationCandidates",
    icon: (
      <span role="img" aria-label="おすすめ候補者" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="おすすめ候補者" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
  {
    title: FW.F_W_HOME_FAN,
    path: "/fans",
    icon: (
      <img
        src="/images/icons/fans.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/fans_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
  {
    title: FW.F_W_HOME_FANCOUNT,
    path: "/countFans",
    icon: (
      <img
        src="/images/icons/count.svg"
        alt=""
        color="#cccccc"
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/count_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

// ゲスト用
export const fansGroupBarForGuest_8 = [
  {
    title: FW.F_W_HOME_JOIN,
    path: "/joinInfoForGuest",
    icon: (
      <img
        src="/images/icons/user.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
    clickedIcon: (
      <img
        src="/images/icons/user_active.svg"
        alt=""
        style={{ width: "25px", objectFit: "contain" }}
      />
    ),
  },
];

// 広告
export const adGroupBar = [
  {
    title: "統計",
    path: "/adDisplayInfo",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
  {
    title: "広告一覧",
    path: "/adList",
    icon: (
      <span role="img" aria-label="広告一覧" style={{ fontSize: "20px" }}>
        📋
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="広告一覧" style={{ fontSize: "20px" }}>
        📋
      </span>
    ),
  },
];

// アナリティクス
export const analyticsGroupBar = [
  {
    title: "アプリインストール状況",
    path: "/appInstall",
    icon: <span role="img" aria-label="インストール">📱</span>,
    clickedIcon: <span role="img" aria-label="インストール">📱</span>,
  },
  {
    title: "ユーザー分析",
    path: "/analytics",
    icon: (
      <span role="img" aria-label="アナリティクス">
        📊
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="アナリティクス">
        📊
      </span>
    ),
  },
];

// バナー
export const bannerGroupBar = [
  {
    title: "大バナー",
    path: "/bannerManage",
    icon: (
      <span role="img" aria-label="大バナー" style={{ fontSize: "20px" }}>
        🖼️
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="大バナー" style={{ fontSize: "20px" }}>
        大
      </span>
    ),
  },
  {
    title: "小バナー",
    path: "/smallBannerManage",
    icon: (
      <span role="img" aria-label="小バナー" style={{ fontSize: "20px" }}>
        🧑‍🤝‍🧑
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="小バナー" style={{ fontSize: "20px" }}>
        小
      </span>
    ),
  },
];

// データ移行
export const sysGroupBar = [
  {
    title: "ユーザー変更履歴",
    path: "/admin/user/change-history",
    icon: <span role="img" aria-label="ユーザー変更履歴">📋</span>,
    clickedIcon: <span role="img" aria-label="ユーザー変更履歴">📋</span>,
  },
  {
    title: "データ移行",
    path: "/dataIko",
    icon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="データ移行" style={{ fontSize: "20px" }}>
        🔄
      </span>
    ),
  },
];

// ゲスト用
export const adGroupBar_7 = [
  {
    title: "統計",
    path: "/dashboard",
    icon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
    clickedIcon: (
      <span role="img" aria-label="統計" style={{ fontSize: "20px" }}>
        🎯
      </span>
    ),
  },
];

export const isMenuPathActive = (pathname, path) =>
  path !== "/" && (pathname === path || pathname.startsWith(path + "/"));

export function getMenuCategories(userFlg) {
  return [
    {
      key: "base",
      title: "≡基本",
      items: menuGroupBar,
    },
    ...(userFlg === "9"
      ? [
          {
            key: "approval",
            title: "✅承認フロー",
            items: approvalGroupBar,
          },
          {
            key: "fans",
            title: "❤️ファン",
            items: fansGroupBar,
          },
          {
            key: "ad",
            title: "📢広告",
            items: adGroupBar,
          },
          {
            key: "banner",
            title: "🖼️バナー",
            items: bannerGroupBar,
          },
          {
            key: "analytics",
            title: "📊アナリティクス",
            items: analyticsGroupBar,
          },
          {
            key: "sys",
            title: "⚙️システム",
            items: sysGroupBar,
          },
        ]
      : []),
    ...(userFlg === "8"
      ? [
          {
            key: "fans",
            title: "❤️ファン",
            items: fansGroupBarForGuest_8,
          },
        ]
      : []),
    ...(userFlg === "7"
      ? [
          {
            key: "ad",
            title: "📢広告",
            items: adGroupBar_7,
          },
        ]
      : []),
  ];
}
